import { BaseDto } from './base.dto';
import { StockDto } from './stock.dto';

export class AllergenDto extends BaseDto {
  name: string;
  symbol: string;
  photoURL?: string;
  startDate: Date;
  endDate?: Date;
  stock: StockDto[];
  group?: string;
}
